import {
  getYoutubeVideoId,
  getVimeoVideoId,
  uuidv4,
} from '../utils';

export default class BackgroundVideo {
  constructor(el) {
    this.$this = $(el);
    this.classes = {
      pause: 'pause',
      imgPlaceholderVideo: 'img-placeholder-video',
      activeSound: 'active-sound',
      activePause: 'active-pause',
      opacityZero: 'opacity-0',
      isLoadedVideo: 'is-loaded-video',
      opacityZeroIframe: 'opacity-zero-iframe',
    };

    this.elementClasses = {
      iframeVideo: '.js-iframe-video',
    };

    this.type = null;
    this.id = null;
    this.url = null;
    this.player = null;
    this.dom = {
      $iframeVideo: this.$this.find(this.elementClasses.iframeVideo),
      $buttonControlSound: this.$this.find('.btn-control-sound'),
      $buttonPlayPause: this.$this.find('.btn-play-pause'),
      $opacityZeroIframe: this.$this.find(`.${this.classes.opacityZeroIframe}`),
      $videoMp4: this.$this.find('video'),
      $imgPlaceholderVideo: this.$this.find(`.${this.classes.imgPlaceholderVideo}`),
    };
  }

  init() {
    if (this.dom.$iframeVideo.length || this.dom.$videoMp4.length) {
      this.dom.$iframeVideo.attr('id', uuidv4());
      this.getVideoInfo();
      if (this.type === 'youtube') {
        this.handleYoutubeVideo();
      } else if (this.type === 'vimeo') {
        this.handleVimeoVideo();
      } else if (this.type === 'mp4') {
        this.handleMp4Video();
      } else {
        // do nothing
      }
    }
  }

  handleYoutubeVideo() {
    window.addEventListener('youtubePlayerLoaded', () => {
      this.setPlayerYoutube();
      this.addListeners();
    });
  }

  handleVimeoVideo() {
    window.addEventListener('vimeoPlayerLoaded', () => {
      this.setPlayerVimeo();
      this.addListeners();
    });
  }

  handleMp4Video() {
    this.dom.$imgPlaceholderVideo.addClass(this.classes.opacityZero);
    this.addListeners();
  }

  addListeners() {
    this.dom.$buttonControlSound.on('click', (e) => {
      e.preventDefault();
      const $elm = $(e.currentTarget);
      if ($elm.hasClass(this.classes.activeSound)) {
        this.muteVideo();
        $elm.removeClass(this.classes.activeSound);
      } else {
        this.unMuteVideo();
        $elm.addClass(this.classes.activeSound);
      }
    })
    this.dom.$buttonPlayPause.on('click', (e) => {
      e.preventDefault();
      const $elm = $(e.currentTarget);
      if ($elm.hasClass(this.classes.activePause)) {
        this.playVideo();
        $elm.removeClass(this.classes.activePause);
      } else {
        this.pauseVideo();
        $elm.addClass(this.classes.activePause);
      }
    })
  }

  /* eslint-disable */
  getVideoInfo() {
    if (this.dom.$videoMp4.length) {
      this.type = 'mp4';
      this.player = this.dom.$videoMp4[0];
      return false;
    }

    const src = this.dom.$iframeVideo.attr('data-src');
    const youtubeVideoId = getYoutubeVideoId(src);
    const vimeoVideoId = getVimeoVideoId(src);
    if (youtubeVideoId) {
      this.type = 'youtube';
      this.id = youtubeVideoId;

      return false;
    }

    if (vimeoVideoId) {
      this.type = 'vimeo';
      this.url = src;
      return false;
    }

    return true;
  }

  setPlayerYoutube() {
    this.player = new window.YT.Player(this.dom.$iframeVideo[0], {
      height: '',
      width: '',
      videoId: this.id,
      host: 'https://www.youtube-nocookie.com',
      playerVars: {
        autoplay: 1,
        loop: 1,
        mute: 1,
        controls: this.dom.$iframeVideo.parents('.mod-resource-detail').length > 0 ? 1 : 0,
        rel: 0,
        playlist: this.id,
        modestbranding: 0,
        showinfo: 0,
        autohide: 1,
      },
      events: {
        onReady: () => {
          $(this.player.g).attr('tabindex', '-1').removeAttr('frameborder');
          this.$this.addClass(this.classes.isLoadedVideo).addClass('youtube-video');
        },
        onStateChange: (e) => {
          if (e.data > 0) {
            this.$this.find(this.elementClasses.iframeVideo).removeClass(this.classes.opacityZero);
          }
          if (e.data === window.YT.PlayerState.PLAYING) {
            this.dom.$imgPlaceholderVideo.addClass(this.classes.opacityZero);
            this.dom.$opacityZeroIframe.removeClass(this.classes.opacityZero);
          }
        },
      },
    });
  }

  setPlayerVimeo() {
    this.player = new window.Vimeo.Player(this.dom.$iframeVideo[0], {
      url: this.url,
      autoplay: true,
      loop: true,
      muted: true,
      controls: true,
      background: true,
    });

    this.player.ready().then(() => {
      $(this.player.element).attr('tabindex', '-1')
        .removeAttr('frameborder')
        .removeAttr('width')
        .removeAttr('height')
        .addClass('iframe-full-section aspect-video mb-aspect-ratio z-1 transform-center-middle absolute pointer-events-none w-full');
      this.$this.addClass(this.classes.isLoadedVideo).addClass('vimeo-video');
    });
    this.player.on('play', () => {
      this.$this.find(this.elementClasses.iframeVideo).removeClass(this.classes.opacityZero);
      this.dom.$imgPlaceholderVideo.addClass(this.classes.opacityZero);
      this.dom.$opacityZeroIframe.removeClass(this.classes.opacityZero);
    });
  }

  pauseVideo() {
    if (this.player) {
      if (this.type === 'youtube' && this.player.pauseVideo) {
        this.player.pauseVideo();
      } else {
        this.player.pause();
      }
    }
  }

  isRacingAndEndVideo() {
    return this.$el.hasClass(this.classes.modRacing) && this.$el.hasClass(this.classes.endVideo);
  }

  playVideo() {
    if (this.player) {
      if (this.type === 'youtube' && this.player.playVideo) {
        this.player.playVideo();
      } else {
        this.player.play();
      }
    }
  }

  muteVideo() {
    if (!this.player) {
      return false;
    }

    if (this.type === 'youtube') {
      this.player.mute();
      return false;
    }

    if (this.type === 'vimeo') {
      this.player.setVolume(0);
      return false;
    }

    if (this.type === 'mp4') {
      this.player.muted = true;
      return false;
    }
    return true;
  }

  unMuteVideo() {
    if (!this.player) {
      return false;
    }

    if (this.type === 'youtube') {
      this.player.unMute();
      setTimeout(() => {
        this.player.setVolume(100);
      }, 10);
      return false;
    }

    if (this.type === 'vimeo') {
      this.player.setVolume(1);
      return false;
    }

    if (this.type === 'mp4') {
      this.player.muted = false;
      return false;
    }
    return true;
  }
}
/* eslint-enable */
$('.js-background-video').each((_i, e) => {
  new BackgroundVideo(e).init();
});
